import { useState } from "react";
import { Dialog, IconButton, Tooltip } from "@mui/material";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import Translate from "../../utils/Translate";
import SelectActorMatchDialog from "./dialogs/SelectActorMatchDialog";

export default function SelectActorMatchButton({
  originalDetails,
  matches,
  selectedActorId,
  onSelect,
  getMatchDetails,
  tooltipText,
  isCompany,
}) {
  const [open, setOpen] = useState(false);

  if (!matches || matches.length === 0) return null;

  const isSelected = selectedActorId !== null;

  return (
    <>
      <Tooltip title={tooltipText ?? Translate.get("PotentialMatches")}>
        <IconButton onClick={() => setOpen(true)} sx={isSelected ? undefined : { backgroundColor: "pink" }}>
          <PeopleAltIcon sx={isSelected ? undefined : { color: "#f05032" }} />
        </IconButton>
      </Tooltip>
      {open && (
        <SelectActorMatchDialog
          originalDetails={originalDetails}
          matches={matches}
          selectedActorId={selectedActorId}
          onSelect={(id) => {
            onSelect(id);
            setOpen(false);
          }}
          onClose={() => setOpen(false)}
          getMatchDetails={getMatchDetails}
          isCompany={isCompany}
        />
      )}
    </>
  );
}
